<template>
  <div>
    <slot/>
    <FileList :auctionId="auctionId" :files="files" :deleteCallback="removeFile" :mutable="mutable" :loading="loading > 0" />
    <FileUpload :auctionId="auctionId" :uploadCallback="addFile" :usecase="usecase" v-if="mutable" />
  </div>
</template>

<script>
  import FileList from './FileList.vue'
  import FileUpload from './FileUpload.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'FileBox',
    components: {
      FileList,
      FileUpload
    },
    props: {
      auctionId: {
        type: Number,
        required: true
      },
      usecase: {
        type: String,
        required: true
      },
      mutable: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        loading: 0,
        files: []
      }
    },
    computed: {
      ...mapGetters(['subdomain'])
    },
    created() {
      this.loading = 0
      const visibilities = this.usecase === 'buyerdocs' ? ['PRIVATE'] : ['PUBLIC','LOGGED_IN','AUTHORIZED']
      visibilities.forEach(visibility => {
        console.log('getAuctionFiles visibility [%s]', visibility)
        this.loading++
        this.$PfxBackendApi.getAuctionFiles(this.subdomain, this.auctionId, visibility).then(res => {
          console.log('getAuctionFiles res', res)
          res.data.forEach(file => this.files.push(file))
        }).catch(err => {
          console.error('getAuctionFiles err', err)
          this.$notify({ type: 'danger', message: 'Cannot fetch the auction documents' })
        }).then(() => {
          this.loading--
        })
      })
    },
    methods: {
      addFile(file) {
        this.files.push(file)
      },
      removeFile(fileId) {
        this.files = this.files.filter(file => file.id !== fileId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/elements/FileBox.vue